import { createAsyncThunk } from '@reduxjs/toolkit';
import { prepareUser } from '../../mappers/user';
import { getUser } from '../../services/getUser';
import { setUser } from '../../slices';
import { IThunkApi } from '../../types/redux/store';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const getUserAction = createAsyncThunk<void, void, IThunkApiExtended>(
  'user/getUser',
  async (_, { extra: context, dispatch }) => {
    try {
      const userData = await getUser(context);

      const user = prepareUser(userData);
      dispatch(setUser(user));
    } catch (ex) {
      const { logger } = context;
      logger.error(ex, {
        domain: 'thunks/user/getUserAction',
      });

      throw ex;
    }
  },
);
